import { ShieldCheck, ChevronDown } from 'lucide-react';
import React, { useState } from "react";
export default function LegalCheck({ api, client }) {
  const [data, setData] = useState(null),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  if (!client) return null;
  return (
    <details className="crmToolCard">
      <summary><span className="crmToolIcon crmToolIconLegal"><ShieldCheck size={18} aria-hidden="true" /></span><span className="crmToolText"><strong>Vérifier l’entreprise</strong><small>Procédures collectives · BODACC</small></span><ChevronDown className="crmToolChevron" size={17} aria-hidden="true" /></summary>
      <div className="crmToolBody space-y-2">
        <p>
          La recherche utilise le SIREN de cette entreprise. Une publication
          ne prouve pas qu’une procédure est encore en cours : un responsable doit vérifier la situation.
        </p>
        <button
          type="button"
          className="secondary"
          disabled={busy || (!client.siret && !client.siren)}
          onClick={async () => {
            setBusy(true);
            setError("");
            try {
              const result = await api.post(
                `commercial/clients/${encodeURIComponent(client.client_id || client.id)}/legal-check`,
              );
              setData(result.data);
            } catch (e) {
              setError(
                e.response?.data?.message || "Consultation indisponible.",
              );
            } finally {
              setBusy(false);
            }
          }}
        >
          {busy ? "Consultation…" : "Consulter les publications"}
        </button>
        {!client.siret && !client.siren && (
          <p>Renseignez d’abord un SIREN ou SIRET fiable.</p>
        )}
        {error && (
          <p role="alert" className="text-red-700">
            {error}
          </p>
        )}
        {data && (
          <>
            <p>
              {
                {
                  publications_found: "Publications retrouvées",
                  no_publication_found:
                    "Aucune publication retrouvée pour ce SIREN",
                  unavailable: "Source momentanément indisponible",
                }[data.status]
              }
            </p>
            <p className="text-sm">{data.lastError || data.message}</p>
            {data.checkedAt && (
              <p className="text-sm">
                Consulté le {new Date(data.checkedAt).toLocaleString("fr-FR")} ·
                SIREN {data.siren}
              </p>
            )}
            {data.status !== "unavailable" &&
              (data.records || []).map((row) => (
                <p key={row.id}>
                  <a
                    className="text-blue-700 underline"
                    href={row.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {row.publicationDate} · {row.nature}
                  </a>
                </p>
              ))}
            {data.truncated && (
              <p>
                Affichage des 100 publications les plus récentes sur{" "}
                {data.totalCount}.
              </p>
            )}
          </>
        )}
      </div>
    </details>
  );
}
